import { useTranslation } from 'react-i18next'
import { App, Form, Input } from 'antd';
import { useImperativeHandle, forwardRef } from 'react';
import { useSearchParams } from 'react-router-dom'
import { importMeddra } from '@/api/dictionary'
import CustomUpload from './customUpload';

const MeddraForm = (props: any, ref: any)=> {
    const { message } = App.useApp();
    const { t } = useTranslation()
    const [form] = Form.useForm()
    const [searchParams] = useSearchParams()
    const dictName = searchParams.get('dictName') || ''

    const onFinish = async ()=>{
        try {
            const values = await form.validateFields()
            const params = new FormData()
            params.append('mdhierFile', values.mdhierFile.file);
            params.append('lltFile', values.lltFile.file);
            await importMeddra(dictName, values.version, params);
            message.success(t('ikg.success', { action: t('dict.addVersion') }))
          } catch (error) {
            throw error
          }
    }

    useImperativeHandle(ref, () => {
        return {
          submit: onFinish,
          resetFields: ()=> {form.resetFields()}
        };
      }, []);

    return <Form
        layout="vertical"
        form={form}
        autoComplete="off"
        initialValues={{
            dictName
        }}
    >
        <Form.Item
            label={t('dict.dictName')} // 字典名称
            name="dictName"
        >
            <Input disabled />
        </Form.Item>
        <Form.Item
        label={t('dict.version')} // 字典名称
        name="version"
        rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.version') }),
            },
        ]}
        >
            <Input placeholder={t('ikg.input', { name: t('dict.version') })} />
        </Form.Item>
        <Form.Item label={t('dict.mdhierAsc')} name="mdhierFile"
            rules={[
                {
                required: true,
                message: t('ikg.input', { name: t('dict.mdhierAsc') }),
                },
            ]}
        >
            <CustomUpload accept=".asc" fileName='mdhier.asc' />
        </Form.Item>
        <Form.Item label={t('dict.lltAsc')} name="lltFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.lltAsc') }),
            },
        ]}>
            <CustomUpload accept=".asc" fileName='llt.asc' />
        </Form.Item>
    </Form>
}

export default forwardRef(MeddraForm)
